<!-- Follow Up inline-edit cell template -->
<ng-template #followUpTemplate let-row let-value="value">
  @if (editingUserId() === row.user_id) {
    <input
      class="inline-edit-input"
      [id]="'fup-' + row.user_id"
      [value]="editValue()"
      (input)="editValue.set($any($event.target).value)"
      (blur)="saveFollowUp(row)"
      (keyup.enter)="$any($event.target).blur()"
      (keyup.escape)="cancelEdit(); $any($event.target).blur()"
      (click)="$event.stopPropagation()"
    />
  } @else {
    <span
      class="editable-cell"
      (click)="startEdit(row, $event)"
      title="{{ value || 'Click to add follow-up' }}"
    >{{ value || '—' }}</span>
  }
</ng-template>

<!-- Access Level inline-edit cell template -->
<ng-template #accessLevelTemplate let-row let-value="value">
  @if (isOwnAccount(row)) {
    <span class="access-readonly" title="You cannot change your own access level">{{ value }}</span>
  } @else {
    <select
      class="access-select"
      [disabled]="changingAccessId() === row.user_id"
      (click)="$event.stopPropagation()"
      (change)="changeAccess(row, $any($event.target).value)"
    >
      @for (option of accessLevelOptions; track option.value) {
        <option [value]="option.value" [selected]="option.value === value">{{ option.label }}</option>
      }
    </select>
  }
</ng-template>

<div class="main-content">
  <div class="header-actions">
    <h4 class="card-title">User List</h4>
    <fh-refresh-button [refresh]="refreshData" />
  </div>

  <!-- showResetButton=false: Reset button is injected inline as the 3rd grid slot -->
  <fh-filter-bar [showResetButton]="false">
    <fh-form-autocomplete
      [options]="countryOptions()"
      label="Country"
      [placeholder]="'Select country...'"
      [showCounts]="true"
      appearance="outline"
      [formControl]="countryFilterFormControl"
      (selectionChange)="onCountryChange($any($event))"
    />

    <fh-form-autocomplete
      [options]="accessOptions"
      label="Access"
      [placeholder]="'Select access...'"
      [showCounts]="false"
      appearance="outline"
      [formControl]="accessFilterFormControl"
      (selectionChange)="onAccessChange($any($event))"
    />

    <fh-form-autocomplete
      [options]="outreachOptions"
      label="Email Outreach"
      [placeholder]="'Any'"
      [showCounts]="false"
      appearance="outline"
      [formControl]="outreachFilterFormControl"
      (selectionChange)="onOutreachChange($any($event))"
    />

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search Users</mat-label>
      <input
        matInput
        [value]="searchText()"
        (input)="searchText.set($any($event.target).value)"
        (keyup.enter)="onSearchChange(searchText())"
        placeholder="Search by name, email..."
      />
      <button matSuffix mat-icon-button (click)="onSearchChange(searchText())">
        <mat-icon>search</mat-icon>
      </button>
      @if (searchText()) {
        <button
          matSuffix
          mat-icon-button
          (click)="searchText.set(''); onSearchChange('')"
          class="clear-button"
        >
          <mat-icon>clear</mat-icon>
        </button>
      }
    </mat-form-field>

    <!-- 3rd grid slot: Reset button sits inline to the right of Search Users -->
    <div class="reset-inline">
      <button mat-stroked-button (click)="onResetFilters()" class="reset-btn">
        <mat-icon>refresh</mat-icon>
        Reset Filters
      </button>
    </div>
  </fh-filter-bar>

  <fh-data-table
    [config]="tableConfig()"
    [sortProp]="sortProp()"
    [sortDir]="sortDir()"
    [pageIndex]="pageIndex()"
    [pageSize]="pageSize()"
    [actions]="tableActions()"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
  />
</div>
